import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { cn } from "@/lib/utils";
import { Button, Icon, RadioGroup, RadioLabel, Typography } from "@bookips/sds";
import { useState } from "react";
export const AddressManagementList = (param)=>{
    let { handleAddStepClick , onChangeAddress , defaultAddressId , listData , onEditClick , onDeleteClick , onClose  } = param;
    const [selectedAddressId, setSelectedAddressId] = useState(defaultAddressId);
    const handleDefaultAddressChange = (value)=>{
        setSelectedAddressId(value);
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "w-full h-full max-h-[calc(100vh-96px)] flex flex-col gap-5",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "px-7 max-sm:px-0",
                        children: /*#__PURE__*/ _jsx(Button, {
                            variant: "stroke",
                            size: "lg",
                            className: "w-full",
                            color: "secondary",
                            onClick: ()=>{
                                handleAddStepClick();
                            },
                            children: /*#__PURE__*/ _jsxs(Typography, {
                                variant: "subtitle1",
                                className: "flex items-center justify-center gap-2",
                                children: [
                                    /*#__PURE__*/ _jsx(Icon.Plus_2px, {
                                        className: "size-5"
                                    }),
                                    "배송지 추가"
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "flex-1 min-h-0 overflow-y-auto max-sm:px-0 max-h-[calc(100vh-408px)] px-7",
                        children: /*#__PURE__*/ _jsx(RadioGroup, {
                            className: "flex flex-col gap-3 max-sm:gap-2",
                            onValueChange: (value)=>handleDefaultAddressChange(value),
                            value: selectedAddressId,
                            children: listData.map((address)=>{
                                /*#__PURE__*/ return _jsx(RadioLabel, {
                                    size: "md",
                                    value: address.id,
                                    classes: {
                                        root: cn("w-full h-full items-baseline p-5 max-sm:p-4 border border-gray-100 rounded-md", address.id === selectedAddressId && "border-primary-main bg-indigo-0"),
                                        label: "w-full"
                                    },
                                    children: /*#__PURE__*/ _jsxs("div", {
                                        className: "flex flex-col gap-3",
                                        children: [
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "flex flex-col gap-3 flex-1",
                                                children: [
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "flex flex-col gap-1.5",
                                                        children: [
                                                            /*#__PURE__*/ _jsxs(Typography, {
                                                                variant: "subtitle1",
                                                                className: "flex gap-2",
                                                                children: [
                                                                    address.recipientName,
                                                                    /*#__PURE__*/ _jsx(Typography, {
                                                                        as: "span",
                                                                        variant: "subtitle1",
                                                                        className: "text-secondary",
                                                                        children: address.addressName
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ _jsx(Typography, {
                                                                variant: "body1",
                                                                className: "text-secondary",
                                                                children: address.phone
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        children: [
                                                            /*#__PURE__*/ _jsx(Typography, {
                                                                variant: "body1",
                                                                children: address.address1
                                                            }),
                                                            /*#__PURE__*/ _jsx(Typography, {
                                                                variant: "body1",
                                                                children: address.address2
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsx(Typography, {
                                                        variant: "body1",
                                                        className: "text-secondary break-all",
                                                        children: address.deliveryNote
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "flex gap-2 justify-end",
                                                children: [
                                                    /*#__PURE__*/ _jsx(Button, {
                                                        variant: "stroke",
                                                        size: "sm",
                                                        color: "secondary",
                                                        onClick: ()=>{
                                                            return onEditClick === null || onEditClick === void 0 ? void 0 : onEditClick(address.id);
                                                        },
                                                        children: "수정"
                                                    }),
                                                    /*#__PURE__*/ _jsx(Button, {
                                                        variant: "stroke",
                                                        size: "sm",
                                                        color: "secondary",
                                                        onClick: ()=>{
                                                            return onDeleteClick === null || onDeleteClick === void 0 ? void 0 : onDeleteClick(address.id);
                                                        },
                                                        children: "삭제"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }, address.id);
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "sticky bottom-0 h-[104px] bg-white flex justify-end gap-2 p-7 max-sm:px-0 max-sm:py-7 shrink-0 max-sm:h-[96px]",
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "stroke",
                        size: "lg",
                        color: "secondary",
                        onClick: onClose,
                        className: "max-sm:w-full",
                        children: "닫기"
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        variant: "fill",
                        size: "lg",
                        color: "primary",
                        className: "max-sm:w-full",
                        onClick: ()=>onChangeAddress(selectedAddressId),
                        children: /*#__PURE__*/ _jsx(Typography, {
                            variant: "subtitle1",
                            className: "flex items-center justify-center gap-2",
                            children: "선택완료"
                        })
                    })
                ]
            })
        ]
    });
};
